import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification is-danger is-light"
}
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "section-card transactions" }
const _hoisted_5 = { class: "custom-card-title title-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionItem = _resolveComponent("TransactionItem")!

  return (_ctx.hasLoadingError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$gettext(
          "An unexpected issue occurred while loading the " +
            "top up request list. Sorry for the inconvenience"
        )), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$gettext(
          "You can try to refresh the page, if the issue " +
            "persists, you may want to contact your " +
            "administrator"
        )), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$gettext("Top up requests waiting for approval")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topUpsPendingForApproval, (transaction) => {
            return (_openBlock(), _createBlock(_component_TransactionItem, {
              key: transaction,
              transaction: transaction,
              type: "topUpsPendingForApproval",
              onRefreshTransaction: _ctx.refreshTransaction,
              onRefreshAccounts: _ctx.refreshAccounts
            }, null, 8, ["transaction", "onRefreshTransaction", "onRefreshAccounts"]))
          }), 128))
        ])
      ]))
}